const PHRASES = ["From delusions", "to psychiatric wards", "to faith", "to recovery", "and the extraordinary gift of an ordinary life"];

export const Marquee = () => {
  const row = [...PHRASES, ...PHRASES];
  return (
    <section data-testid="editorial-marquee" className="relative border-y border-[#e3ba73]/15 py-8 overflow-hidden bg-[#16121b]">
      <div className="marquee-track flex w-max whitespace-nowrap">
        {[0, 1].map((k) => (
          <div key={k} className="flex shrink-0" aria-hidden={k === 1}>
            {row.map((p, i) => (
              <span key={`${k}-${i}`} className="flex items-center font-serif-d italic text-3xl sm:text-5xl text-[#f4ede2]/90 px-8">
                {p}
                <svg className="ml-16" width="28" height="12" viewBox="0 0 28 12"><path d="M1 6c3-6 6-6 8 0s5 4 7 0 4-2 5 0h6" fill="none" stroke="#e3ba73" strokeWidth="1.5" strokeLinecap="round" /></svg>
              </span>
            ))}
          </div>
        ))}
      </div>
    </section>
  );
};
